'use client';

import {
  CategoryProductFragment,
  ProductFragment,
} from '@business/gql/graphql';
import config from '@utils/config';
import currencies from '@utils/currency/currencies';
import { gTagViewItemList } from '@utils/googleTags';
import { Maybe } from 'graphql/jsutils/Maybe';
import { useEffect } from 'react';
import { PageGTMInfo } from '@ui/components/Product/ProductSearch';

type Props = {
  products: Maybe<ProductFragment | CategoryProductFragment>[];
  gtmInfo: PageGTMInfo;
};

export default function ProductsGoogleTagManager(props: Props) {
  const { products, gtmInfo } = props;

  useEffect(() => {
    if (products && gtmInfo) {
      gTagViewItemList(products, currencies[config.market], gtmInfo);
    }
  }, [products, gtmInfo]);

  return null;
}
